import { BlankSlate, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Page from 'modules/layout/components/Page'

const NotFound = () => (
  <Page>
    <Box height="full" justifyContent="center" alignItems="center">
      <BlankSlate
        illustration="sign-post"
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    </Box>
  </Page>
)

export default NotFound
